// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo__logo--white--1pBLJ"};
    if(module.hot) {
      // 1571674783084
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  